/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import PageStatus from './scripts/page-status';
import Slider from './scripts/slider';
import Accordion from './scripts/accordion';
import Buttons from './scripts/buttons';
import VideoButton from './scripts/videobutton';

const scripts = [PageStatus, Slider, Accordion, Buttons, VideoButton];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});
